var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM12.8105 12.8105C12.5567 13.0643 12.1451 13.0643 11.8913 12.8105L10.0001 10.9192L8.10879 12.8105C7.85495 13.0643 7.4434 13.0643 7.18956 12.8105C6.93572 12.5566 6.93572 12.1451 7.18956 11.8912L9.08081 9.99999L7.18956 8.10873C6.93572 7.85489 6.93572 7.44334 7.18956 7.1895C7.4434 6.93565 7.85496 6.93565 8.1088 7.1895L10.0001 9.08075L11.8913 7.1895C12.1451 6.93566 12.5567 6.93566 12.8105 7.1895C13.0644 7.44334 13.0644 7.8549 12.8105 8.10874L10.9193 9.99999L12.8105 11.8912C13.0644 12.1451 13.0644 12.5566 12.8105 12.8105Z",
    fill: "#BF4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessFailed);
export default __webpack_public_path__ + "static/media/process-failed.a26c5f9a25c32ca6ef4f7bcae84368d6.svg";
export { ForwardRef as ReactComponent };